import { Component, OnInit,ElementRef, ViewChild,AfterViewInit } from '@angular/core';
import { MDBModalRef,MDBModalService } from 'angular-bootstrap-md';
import { Subject } from 'rxjs';

import { UtilitarioService } from 'src/app/service/utilitarios/utilitario.service';
import { MaeAulaVirtualService } from 'src/app/service/mae-aulavirtual.service';
import { GlobalVariablesService } from 'src/app/service/global-variables.service';
import { DetParticipanteService } from 'src/app/service/det-participante.service';

import { DetParticipanteE,DetParticipanteM } from 'src/app/model/det-participante-bean';
import { MaeAVParticipantesM } from 'src/app/model/mae-aulavirtual-bean';
import { AuditoriaBeanM } from 'src/app/model/auditoria_bean';
import { Response_dml_bean } from 'src/app/model/response-dml';

@Component({
  selector: 'app-dml-participante-av',
  templateUrl: './dml-participante-av.component.html',
  styleUrls: ['./dml-participante-av.component.scss']
})
export class DmlParticipanteAVComponent implements OnInit {

  //action del padre para el retorno de datos
  action: Subject<Response_dml_bean> = new Subject();
  rspta_padre = new Response_dml_bean();
  al_agregados:number=0;

  //variables enviado desde el padre
  id_curso:String;
  c_tipo:String;
  x_tipo:String;
  id_constancia:String;
  //x_prefijo_constancia:String;
  muestra_nota:boolean;

  listParticipantesAV = new Array<MaeAVParticipantesM>();
  listParticipantesCompletoAV = new Array<MaeAVParticipantesM>();

  nota_base:number=0;
  //agregar
  ParticipanteE = new DetParticipanteE();

  page = 1;
  pageSize = 10;
  headElements = ['Nro','Nombre','Email','Nota',''];

  constructor(
    public  modalRefParticipanteDml: MDBModalRef,
    private utilitarioService:UtilitarioService,
    private maeAulaVirtual:MaeAulaVirtualService,
    private globalVariablesService:GlobalVariablesService,
    private detParticipanteService:DetParticipanteService,
  ){}

  ngOnInit(): void {
    this.cargarDatoInicial();
  }
  cargarDatoInicial(){
    this.rspta_padre.codigoRespuestaServicio ="0";
    this.rspta_padre.mensaje="";
    this.utilitarioService.loading = true;
    const cargarParticipantesAV = this.maeAulaVirtual.getParticipantes(this.id_curso.toString(),this.c_tipo.toString()).toPromise()
    .then(result => {
      this.muestra_nota=this.c_tipo==="19";
      this.listParticipantesCompletoAV = result;
      this.listParticipantesAV = result;
    });
    Promise.all([cargarParticipantesAV])
    .then(response => {

      this.utilitarioService.loading = false;
    });
  }

  onAgregar(maeAVParticipanteM:MaeAVParticipantesM){

    let auditoriaBeanM = new AuditoriaBeanM();
    auditoriaBeanM = this.globalVariablesService.getAuditoriaServicio('I');
    this.ParticipanteE.auditoriaBeanM = auditoriaBeanM;

    this.ParticipanteE.c_constancia = this.id_constancia;
    this.ParticipanteE.c_tipo = this.c_tipo;
    this.ParticipanteE.c_userid = maeAVParticipanteM.id.toString();
    this.ParticipanteE.x_nombres = maeAVParticipanteM.nombres;
    this.ParticipanteE.x_correo = maeAVParticipanteM.email;
    this.ParticipanteE.x_nota = maeAVParticipanteM.dato;
    this.ParticipanteE.x_nro_constancia = "0";
    this.ParticipanteE.c_estado = 21;
    this.ParticipanteE.x_uid_doc = "0";
    this.ParticipanteE.x_uid_pdf = "0";
    this.ParticipanteE.l_envio_correo = "0";

console.log(this.ParticipanteE);

    this.utilitarioService.loading=true;
    this.detParticipanteService.insert(this.ParticipanteE).subscribe((response_dml_bean:Response_dml_bean)=>{

      this.utilitarioService.loading=false;
      if (response_dml_bean.codigoRespuestaServicio=="1"){
        this.utilitarioService.toastrSuccess(response_dml_bean.mensaje);
        //this.onClosemodal();
        this.rspta_padre.codigoRespuestaServicio = "1";
        this.al_agregados++;
        if(this.al_agregados>1)
          this.rspta_padre.mensaje ="Se agrego "+this.al_agregados.toString()+ " "+this.x_tipo;
      }
      else
        this.utilitarioService.toastrInfo(response_dml_bean.mensaje);
      maeAVParticipanteM.id = 0;
    },
    error=>{
      this.utilitarioService.loading=false;
      console.log(error);
      this.utilitarioService.toastrError(error.error.messages.toString());
    });
  }

  onAgregarTodos()
  {
    this.utilitarioService.loading=true;
    this.al_agregados = 0;
    var ejecutados = 0;
    let auditoriaBeanM = new AuditoriaBeanM();
    auditoriaBeanM = this.globalVariablesService.getAuditoriaServicio('I');

    var i:number;
    var cero = 0 as Number;
    for(i = 0;i<this.listParticipantesAV.length;i++) {

      if(this.listParticipantesAV[i].id > cero)
      {
        var participanteE = new DetParticipanteE();
        participanteE.c_constancia = this.id_constancia;
        participanteE.c_tipo = this.c_tipo;
        participanteE.c_userid = this.listParticipantesAV[i].id.toString();
        participanteE.x_nombres = this.listParticipantesAV[i].nombres;
        participanteE.x_correo = this.listParticipantesAV[i].email;
        participanteE.x_nota = this.listParticipantesAV[i].dato;
        participanteE.x_nro_constancia = "0";
        participanteE.c_estado = 21;
        participanteE.x_uid_doc = "0";
        participanteE.x_uid_pdf = "0";
        participanteE.l_envio_correo = "0";
        participanteE.auditoriaBeanM = auditoriaBeanM;

        this.detParticipanteService.insert(participanteE).subscribe((response_dml_bean:Response_dml_bean)=>{
          ejecutados++;
          if (response_dml_bean.codigoRespuestaServicio=="1")
            this.al_agregados++;

          if(ejecutados==this.listParticipantesAV.length)
          {
            this.utilitarioService.loading=false;
            if(this.al_agregados>0)
            {
              this.rspta_padre.codigoRespuestaServicio = "1";
              if(this.al_agregados>1)
                this.rspta_padre.mensaje ="Se agrego "+this.al_agregados.toString()+ " participantes";//+this.x_tipo;
              else
                this.rspta_padre.mensaje ="Se agrego un nuevo participante";

              this.onClosemodal();
            }
            else
              this.utilitarioService.toastrInfo("No se agrego ningun participante");
          }
        },
        error=>{
          console.log(error);
        });
      }
      else
      {
        ejecutados++;
        if(ejecutados==this.listParticipantesAV.length)
        {
          this.utilitarioService.loading=false;
          if(this.al_agregados>0)
          {
            if(this.al_agregados>1)
              this.rspta_padre.mensaje ="Se agrego "+this.al_agregados.toString()+ " "+this.x_tipo;
            else
              this.rspta_padre.mensaje ="Se agrego un nuevo participante";

            this.onClosemodal();
          }
          else
            this.utilitarioService.toastrInfo("No se agrego ningun participante");
        }
      }
   }
  }

  onNotaBaseChange()
  {
    this.listParticipantesAV = this.listParticipantesCompletoAV.filter(x=>Number(x.dato)>this.nota_base );
  }
  onClosemodal(){
    this.modalRefParticipanteDml.hide();
    //console.log("se salio");
  }
  ngOnDestroy() {
    // unsubscribe to ensure no memory leaks
    this.action.next(this.rspta_padre);
    //console.log("se salio a la mala "+this.al_agregados.toString());
  }
}
